import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateAge' })
export class DateAge implements PipeTransform {
  transform(fromDate: string, ref: string = 'hours', toDate: string): string {
    if (!toDate) {
      toDate = new Date().toString();
    }
    var fromMs = Date.parse(fromDate);
    var toMs = Date.parse(toDate);
    if (isNaN(fromMs) || isNaN(toMs) || (fromMs > toMs)) {
      return "NaN";
    }

    var deltaSeconds = ((toMs - fromMs) / 1000);

    if (ref === 'hours') {
      var hours = Math.floor(deltaSeconds / 60 / 60);
      return hours.toString();
    }
    if (ref === 'days') {
      var days = Math.floor(deltaSeconds / 60 / 60 / 24);
      var hours = Math.floor((deltaSeconds - (days * 60 * 60 * 24))  / 60 / 60);
      return days.toString() + ':' + hours.toString();
    }
    return "NaN";
  }
}

@Pipe({ name: 'dateAgeBadge' })
export class DateAgeBadge implements PipeTransform {
  transform(fromDate: string, toDate: string): string {
    if (!toDate) {
      toDate = new Date().toString();
    }
    var fromMs = Date.parse(fromDate);
    var toMs = Date.parse(toDate);
    if (isNaN(fromMs) || isNaN(toMs) || (fromMs > toMs)) {
      return "NaN";
    }
    var deltaSeconds = ((toMs - fromMs) / 1000);
    var hours = Math.floor(deltaSeconds / 60 / 60);
    if (hours > 4 * 24) {
      return "badge-danger";
    }
    if (hours > 2 * 24) {
      return "badge-warning";
    }
    return "badge-primary";
  }
}
